import React from 'react'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const useStyles = makeStyles(() => ({
  treeDividerContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  treeDividerLine: {
    width: '1.25rem',
    borderBottom: '3px solid #DEDEDE'
  },
  treeDividerBranches: {
    width: '1.5rem',
    height: '100%',
    borderTopLeftRadius: '1rem',
    borderTopRightRadius: 0,
    borderBottomLeftRadius: '1rem',
    borderBottomRightRadius: 0,
    borderRight: 0,
    border: '3px solid #DEDEDE'
  }
}))

export const TreeBranch = ({
  className
}) => {
  const classes = useStyles()
  return (
    <div className={className}>
      <div className={clsx(classes.treeDividerContainer)}>
        <div className={classes.treeDividerLine} />
        <div className={classes.treeDividerBranches} />
      </div>
    </div>
  )
}
TreeBranch.propTypes = {
  className: PropTypes.string
}
